import { Get, getAPIUrl, Post } from "../../ApiServices/apiMethod";

export const PlinkoEndpoint = {
//   roomDetails: "zoo-roulette/room",
  getOptions: "plinko/options",
  ApplyBet: "plinko/betting",
  HISTORY_URL: "plinko/history",
  roomDetails: "plinko/room",
//   getResult: "zoo-roulette/fetch-result",
//   fetchPlayers: "zoo-roulette/fetch-online-player",
//   mybets: "zoo-roulette/my-games"
};

// BETTING_URL = "plinko/betting"
// HISTORY_URL = "plinko/history"
// OPTIONS_URL = "plinko/option-list"
// WALLET_URL = "user/wallet-balance"
// PROFILE_URL = "user/profile"

// https://ezulix-games.ezulix.co/api/v1/

export const ApplyBetzooRoullete = (data, param = "") => {
  const url = getAPIUrl(PlinkoEndpoint.ApplyBet, param);
  return Post(url, data);
};

export const getWinningHistory = (param = "") => {
  const url = getAPIUrl(PlinkoEndpoint.HISTORY_URL, param);
  return Get(url);
};

export const getPlinkoRoomDetail = (param = "") => {
  const url = getAPIUrl(PlinkoEndpoint.roomDetails, param);
  return Get(url);
};